document.addEventListener("DOMContentLoaded", function () {
// Initialize masonry for visible wrappers on load
  document.querySelectorAll(".hb_media-coverage__wrapper").forEach(wrapper => {
    if (wrapper.offsetParent !== null) { 
      initMasonry(wrapper);
    }
  });
  const tabButtons = document.querySelectorAll(".tab-button");
  tabButtons.forEach(btn => {
    btn.addEventListener("click", function() {
      const targetTab = document.querySelector(this.dataset.target);
      document.querySelectorAll(".tab-content").forEach(tab => {
        if (tab !== targetTab) tab.classList.remove("active");
      });
      targetTab.classList.add("active");
      const wrapper = targetTab.querySelector(".hb_media-coverage__wrapper");
      initMasonry(wrapper);
    });
  });
  // Popup
  const popup = document.querySelector(".hb_custom-popup");
  const popupImg = document.querySelector(".hb_custom-popup__image img");
  const crossIcon = document.querySelector(".hb_custom-popup__cross-icon");
  let pdfIframe = null;
  function isTrigger(el) {
    return el.closest(".hb_media-coverage__img")
        || el.closest(".hb_media-coverage__title")
        || el.closest(".hb_media-coverage__arrow-icon");
  }
if (!window.hbMediaPopupInit) {
  window.hbMediaPopupInit = true;

  document.addEventListener("click", function (e) {
    const trigger = isTrigger(e.target);

    if (!trigger || !popup) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const item = trigger.closest(".hb_media-coverage__item");
    if (!item) return;

    const pdf = item.querySelector("[data-pdf]");

    if (pdf) {
      const url = pdf.getAttribute("data-pdf");

      if (popupImg) popupImg.style.display = "none";

      if (pdfIframe) pdfIframe.remove();

      pdfIframe = document.createElement("iframe");
      pdfIframe.src = url + "#toolbar=0&navpanes=0&scrollbar=0";
      pdfIframe.style.width = "100%";
      pdfIframe.style.height = "600px";
      pdfIframe.style.border = "none";

      if (popupImg?.parentElement) {
        popupImg.parentElement.appendChild(pdfIframe);
      }

      popup.classList.add("active");
      return;
    }

    const img = item.querySelector(".hb_media-coverage__img img");

    if (img && popupImg) {
      popupImg.src = img.src;
      popupImg.alt = img.alt || "";
      popupImg.style.display = "block";

      if (pdfIframe) pdfIframe.remove();
    }

    popup.classList.add("active");
  });
}

  crossIcon?.addEventListener("click", function () {
    popup?.classList.remove("active");
    if (pdfIframe) pdfIframe.remove();
  });
  popup?.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.classList.remove("active");
      if (pdfIframe) pdfIframe.remove();
    }
  });

    // Masonry initialization function
  function initMasonry(wrapper) {
    if (!wrapper || typeof imagesLoaded !== "function" || typeof Masonry !== "function") return;

    imagesLoaded(wrapper, function () {
      new Masonry(wrapper, {
        itemSelector: '.hb_media-coverage__item',
        percentPosition: true,
        gutter: 24,
        horizontalOrder: true,
        fitWidth: true
      });
    });
  }
  // Tabs
  document.querySelectorAll(".hb_tablink").forEach(function(tabBtn) {
    tabBtn.addEventListener("click", function() {
      var tabId = this.getAttribute("data-tab");
      document.querySelectorAll(".hb_tabpanel").forEach(function(panel) {
        panel.style.display = "none";
      });
      document.querySelectorAll(".hb_tablink").forEach(function(btn) {
        btn.classList.remove("active");
      });
      var activePanel = document.getElementById(tabId);
      activePanel.style.display = "block";
      this.classList.add("active");

      // Initialize Masonry for this tab
      var wrapper = activePanel.querySelector(".hb_media-coverage__wrapper");
      initMasonry(wrapper);
    });
  });

  // Initialize Masonry for the first (visible) tab on page load
  document.addEventListener("DOMContentLoaded", function() {
    var firstPanel = document.querySelector(".hb_tabpanel[style*='display: block']");
    if (firstPanel) {
      var wrapper = firstPanel.querySelector(".hb_media-coverage__wrapper");
      initMasonry(wrapper);
    }
  });
  // Update title on tab click
 document.addEventListener("DOMContentLoaded", function () {
  const titleEl = document.querySelector(".hb_custom-richtext__title");
  if (!titleEl) return;
  const activeTab = document.querySelector(".hb_tablink.active");
  if (activeTab) {
    titleEl.textContent = activeTab.textContent.trim();
  }
  document.querySelectorAll(".hb_tablink").forEach(function (tabBtn) {
    tabBtn.addEventListener("click", function () {
      titleEl.textContent = this.textContent.trim();
    });
  });
});
});


